import React from "react";
import {
	Typography,
	FormControl,
	MenuItem,
	FormControlLabel,
	Switch,
} from "@material-ui/core";
import { CssTextField, CssLabel, CssSelect } from "./style";

export const LeagueForm = ({
	classes,
	leagueCount,
	setLeagueCount,
	userId,
	setUserId,
	leagueType,
	setLeagueType,
	isGoldRush,
	setIsGoldRush,
}) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				League Bots
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="Bot Count"
					variant="outlined"
					type="number"
					value={leagueCount}
					onChange={(e) => setLeagueCount(e.target.value)}
					error={
						leagueCount &&
						(parseInt(leagueCount) <= 0 || parseInt(leagueCount) > 200)
					}
					helperText={
						leagueCount && parseInt(leagueCount) <= 0
							? "Bot count must be positive"
							: leagueCount && parseInt(leagueCount) > 200
								? "Bot count must be at most 200"
								: ""
					}
					InputProps={{
						inputProps: { min: 1, max: 200 },
					}}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="User ID"
					variant="outlined"
					value={userId}
					onChange={(e) => setUserId(e.target.value)}
					required
				/>
				<FormControl className={classes.formControl}>
					<CssLabel>League Type</CssLabel>
					<CssSelect
						value={leagueType}
						onChange={(e) => setLeagueType(e.target.value)}
					>
						<MenuItem value="lg">Normal (lg)</MenuItem>
						<MenuItem value="lgc">Cheater (lgc)</MenuItem>
					</CssSelect>
				</FormControl>
				<FormControlLabel
					style={{ color: "white", marginLeft: 16 }}
					control={
						<Switch
							checked={isGoldRush}
							onChange={(e) => setIsGoldRush(e.target.checked)}
							color="default"
						/>
					}
					label="Gold Rush"
				/>
			</div>
		</>
	);
};

export const validateLeagueForm = (formData) => {
	const { leagueCount, userId } = formData;
	return (
		leagueCount &&
		userId &&
		parseInt(leagueCount) > 0 &&
		parseInt(leagueCount) <= 200
	);
};

export const LeagueReceiptExpireForm = ({ classes, userId, setUserId }) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				League Receipt Expire
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="User ID"
					variant="outlined"
					value={userId}
					onChange={(e) => setUserId(e.target.value)}
					helperText="Deletes receipts of all other members in user's league group"
					required
				/>
			</div>
		</>
	);
};

export const validateLeagueReceiptExpireForm = ({ userId }) => {
	return !!userId;
};

export const LeagueChangeForm = ({
	classes,
	userId,
	setUserId,
	leagueChangeLeague,
	setLeagueChangeLeague,
	leagueChangeType,
	setLeagueChangeType,
	isGoldRush,
	setIsGoldRush,
}) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				League Change
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="User ID"
					variant="outlined"
					value={userId}
					onChange={(e) => setUserId(e.target.value)}
					required
				/>
				<FormControl className={classes.formControl}>
					<CssLabel>Target League</CssLabel>
					<CssSelect
						value={leagueChangeLeague}
						onChange={(e) => setLeagueChangeLeague(e.target.value)}
					>
						<MenuItem value={1}>1 - Bronze</MenuItem>
						<MenuItem value={2}>2 - Silver</MenuItem>
						<MenuItem value={3}>3 - Gold</MenuItem>
						<MenuItem value={4}>4 - Diamond</MenuItem>
						<MenuItem value={5}>5 - Crystal</MenuItem>
						<MenuItem value={6}>6 - Titan</MenuItem>
					</CssSelect>
				</FormControl>
				<FormControl className={classes.formControl}>
					<CssLabel>League Type</CssLabel>
					<CssSelect
						value={leagueChangeType}
						onChange={(e) => setLeagueChangeType(e.target.value)}
					>
						<MenuItem value={1}>Normal</MenuItem>
						<MenuItem value={2}>Cheater</MenuItem>
					</CssSelect>
				</FormControl>
				<FormControlLabel
					style={{ color: "white", marginLeft: 16 }}
					control={
						<Switch
							checked={isGoldRush}
							onChange={(e) => setIsGoldRush(e.target.checked)}
							color="default"
						/>
					}
					label="Gold Rush"
				/>
			</div>
		</>
	);
};

export const validateLeagueChangeForm = ({ userId, leagueChangeLeague }) => {
	return !!userId && leagueChangeLeague >= 1 && leagueChangeLeague <= 8;
};
